<template>
  <CCardBody class="TableBalancerecurrentAddOns dataTable__body tableBalance__body p-0" v-if="viewMode.hiddenTable">
    <h4 class="font-weight-normal mb-2">
      {{ $t(`backoffice.manage.balance.tables.table-recurrentAddOns`) }}
    </h4>
    <hr v-if="viewMode.haslineNameTable" />
    <!-- {{ recurrentAddOns }} -->
    <CDataTable
      :key="`recurrentAddOnsSMS`"
      v-if="recurrentNonCanceled.length"
      :fields="itemsFields"
      :responsive="false"
      :items="recurrentNonCanceled"
      :table-filter="{ external: true, lazy: true }"
      items-per-page-select
      :loading="false"
      hover
    >
      <template #country="{ item }">
        <td class="">
          <span>
            <span>
              <img :src="handleCountry(item).flag" width="30" height="auto" />
            </span>
            <span class="ml-2">
              {{ handleCountry(item).label }}
            </span>
          </span>
        </td>
      </template>
      <template #balanceRenewalPeriod="">
        <td class="">
          <span>
            {{ $t('general.subscription.select.monthly') }}
          </span>
        </td>
      </template>
      <template #balance="{ item, index }">
        <td class="position-relative">
          <InputValueSubscription
            :item="item"
            :index="index"
            :key="item.id"
            @toggle-inputValue="toggleInputValueSubscription"
            @save-LineBalance="addRecurring"
            @update-LineBalance="updateRecurring"
          />

          <TableAlert :payload="item" />
        </td>
      </template>
      <template #delete="{ item, index }">
        <td v-if="!item.addOnOrganizationStatus || item.addOnOrganizationStatus == 1" class="position-relative text-center" @click.stop>
          <CButton
            :data-cy="'deleteLine' + index"
            color="white"
            :key="item.id"
            aria-label="delete"
            title="delete"
            class="tableBalance__btn text-gray-600"
            @click.stop="toggleDelete(item, 'recurrentAddOns')"
          >
            <CIcon name="trash" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
          </CButton>

          <transition name="fade" v-if="item._modalDelete">
            <div class="dataTable__popUp dataTable__popUp--right popUp" @click.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete
                  :title="''"
                  :description="$t('backOffice.manage.balace.tables.table-one-shot.text-delete')"
                  @confirm="removeRecurring(item, 'recurrentAddOns')"
                  @cancel="toggleDelete(item, 'recurrentAddOns')"
                />
              </div>
            </div>
          </transition>
        </td>
        <td v-else class="text-center">
          {{ $t(`backoffice.manage.balance.tables.text.canceled`) }}
        </td>
      </template>
    </CDataTable>
    <SelectCountry :removeCountries="countriesToRemove" @add-country="addLine" />
  </CCardBody>
</template>

<script>
import ConfirmationDelete from '@/components/ConfirmationDelete'
import { nameCountries } from '@/utils/countriesUtils.js'
import { actionsRecurring } from '../../mixins/ActionsTransactionsTable'

const fields = [
  { key: 'country', label: 'country' },
  { key: 'balanceRenewalPeriod', label: 'frequency' },
  { key: 'balance', label: 'value' },
  { key: 'delete', label: '', _classes: 'hidden text-center', _style: 'width:50px' },
]

export default {
  name: 'TableBalanceRecurrentSms',
  components: {
    ConfirmationDelete,
    InputValueSubscription: () => import('./InputValueSubscription.vue'),
    TableAlert: () => import('./TableAlert.vue'),
    SelectCountry: () => import('./SelectCountry.vue'),
  },

  mixins: [actionsRecurring],
  props: {
    recurrentAddOns: {
      type: Array,
      default: () => {},
    },
    channel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      subscriptionCountry: null,
    }
  },

  created() {
    this.itemsFields = this.channel == 'sms' ? fields : fields.filter((item) => item.key !== 'country')
  },

  computed: {
    typeAddContent() {
      return this.channel == 'email' ? 'AddValue' : 'SelectCountry'
    },

    hasRecurrentCanceled() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 3).length > 0
    },

    hasRecurrentActive() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 1).length > 0
    },

    countriesToRemove() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 1).map((el) => el.countryId)
    },

    recurrentNonCanceled() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 1)
    },

    viewMode() {
      // se state on e não há indices em recurrentAddOns
      if (this.recurrentAddOns.length == 0) {
        return { hiddenTable: true, haslineNameTable: true }
      }

      return { hiddenTable: true }
    },
  },

  methods: {
    handleCountry(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.countryId.toUpperCase())

      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },

    addLine(newData) {
      let data = {
        addOnOrganizationStatus: 1,
        balanceRenewalPeriod: 1,
        balance: 0,
        countryId: newData.value,
        _channel: this.channel,
        _typeTable: 'recurrentAddOns',
        _tempId: Math.floor(Math.random() * 1000000),
        _currentBalanceTemp: 1,
        _modalChangeValue: false,
        _modalDelete: false,
        _message: {
          dismissCountDown: false,
          text: '',
          status: '',
        },
      }

      this.$store.commit('backOffice/ADD_LINE', { data, table: 'recurrentAddOns' })
    },
  },
}
</script>
